import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';

// import { ourLatestBlogsData } from '../../common';
// import { HashLink as Link } from 'react-router-hash-link';
import BlogCard from './BlogCard';
import { Link } from 'react-router-dom';
import axios from 'axios';
// import userImg1 from '../../assets/images/blog/blog-home/b-01.webp';

const OurLatestBlogs = () => {
    const [blogsData, setBlogsData] = useState([]);
    const [ourLatestBlogsData, setData] = useState([]);

    const getAllOurLatestBlogsData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/ourLatestBlogsData.json');
            setData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }

    useEffect(() => {
        const getBlogs = async () => {
            try {
                const res = await axios.get('/staticDataFiles/data.json');
                const mapped = res.data?.slice(0, 2).map((blog) => ({
                    id: blog?.id,
                    name: blog?.bannerData?.text,
                    createdDate: blog?.bannerData?.subTitle,
                    userImg: '/assets/images/blog/blog-home/b-01.webp',
                    paragraph: blog?.bannerData?.title,
                    heading: blog?.headerData?.title,
                    subTitle: blog?.headerData?.paragraph,
                }));
                setBlogsData(mapped);
            } catch (err) {
                console.error('Error fetching blogs:', err);
            }
        };

        getBlogs();
        getAllOurLatestBlogsData();
    }, []);

    return (
        <section className='our-latest-blogs'>
            <div className="blog-home2 spacer">
                <Container>
                    <div className={`d-flex justify-content-between align-self-start gap-5 pb-4`}>
                        <div>
                            <h2 className="title m-0">{ourLatestBlogsData?.pageHeading}</h2>
                            <h3 className="subtitle m-0">{ourLatestBlogsData?.pageParagraph}</h3>
                        </div>
                        {ourLatestBlogsData?.buttonName && <div className='d-flex align-items-center '>
                            <Link to="/view-all-blog" className="btn View-All-button btn-md">
                                {ourLatestBlogsData?.buttonName}
                            </Link>
                        </div>}
                    </div>
                    {/* <Row className="justify-content-start">
                        <Col md="8" className="text-left">
                            <h2 className="title m-0">{ ourLatestBlogsData?.pageHeading}</h2>
                            <h6 className="subtitle m-0">{ ourLatestBlogsData?.pageParagraph}</h6>
                        </Col>
                    </Row> */}
                    <div className='m-t-40 '>
                        <BlogCard data={blogsData} />
                    </div>
                </Container>
            </div>
        </section>
    );
}

export default OurLatestBlogs;
